import type { NoiseType } from './ambientLoop';
export const AMBIENT_SOUNDS: {id:NoiseType;name:string;description:string;file:string}[] = [
  {id:'brown',name:'Brown noise',description:'A deep, steady backdrop.',file:'brown_noise.mp3'},
  {id:'pink',name:'Rain & pink noise',description:'Soft rain and a gentle wash of sound.',file:'pink_noise_rain.mp3'},
  {id:'underwater',name:'Ocean ambience',description:'A quiet, submerged world.',file:'unterwater_loop.mp3'},
  {id:'campfire',name:'Campfire',description:'Warm crackles beside the trail.',file:'campfire1.mp3'},
  {id:'soaking',name:'Soft resonance',description:'A calm, spacious atmosphere.',file:'soaking1.mp3'},
  {id:'water',name:'Water stream',description:'Flowing water for a little focus.',file:'water1.mp3'},
  {id:'cafe',name:'Café ambience',description:'A little company while you write.',file:'cafe1.mp3'},
];
